export default __webpack_public_path__ + "static/media/P99999.e697cf7e.png";